import React, { useEffect, useState } from "react";
import Icon from "./AppIcon";
import { inIframe, requestHrmsToken, ssoLogin } from "../services/sso";

// phase: 'init' | 'authing' | 'done'
export default function SsoGate({ children }) {
  const [phase, setPhase] = useState("init");

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      // Already authenticated this session. The TMS-origin sessionStorage
      // persists across reloads within the tab, but the iframe always loads
      // the root path ("/" = login screen). If we're sitting on root/login,
      // send the user to their dashboard instead of showing the login form.
      if (sessionStorage.getItem("userId")) {
        const path = window.location.pathname;
        const onEntry = path === "/" || path === "" || path.includes("login");
        if (onEntry) {
          const role = sessionStorage.getItem("userRole");
          window.location.replace(role === "MANAGER" ? "/manager-dashboard" : "/trainee-dashboard");
          return;
        }
        setPhase("done");
        return;
      }

      // Direct (non-iframe) access: let the normal app/login render.
      if (!inIframe()) {
        setPhase("done");
        return;
      }

      // Embedded in HRMS: attempt silent SSO bootstrap.
      setPhase("authing");
      const token = await requestHrmsToken();
      if (cancelled) return;

      if (token) {
        const redirect = await ssoLogin(token);
        if (cancelled) return;
        if (redirect) {
          // Full reload; on reload userId is set so this gate passes through.
          window.location.replace(redirect);
          return;
        }
        // SSO failed: fall back to the login screen.
        setPhase("done");
      } else {
        // No token arrived: fall back to the login screen.
        setPhase("done");
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, []);

  if (phase === "init" || phase === "authing") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground">
        <Icon name="Loader" size={28} className="animate-spin text-primary" />
        <p className="mt-4 text-sm text-muted-foreground">Signing in…</p>
      </div>
    );
  }

  return children;
}
